import React, { useState } from 'react';
import ReactDOM from 'react-dom';
import { useI18n } from '../../i18n';
import { FaTimes } from 'react-icons/fa';
import { useEmail } from '../../context/EmailContext';
import '../Projects/ProjectComposer.css';
import './EmailSection.css';

const SYSTEM_FOLDER_ORDER = ['inbox', 'sent', 'drafts', 'spam', 'trash', 'custom'];

const FolderIcon = ({ type }) => {
    const props = { width: 18, height: 18, fill: 'none', stroke: 'currentColor', strokeWidth: '1.75', strokeLinecap: 'round', strokeLinejoin: 'round' };
    if (type === 'inbox') return (
        <svg {...props} viewBox="0 0 20 20"><path d="M18.3327 10H13.3327L11.666 12.5H8.33268L6.66602 10H1.66602" /><path d="M4.54102 4.25313L1.66602 9.99479V14.9948C1.66602 15.4368 1.84161 15.8607 2.15417 16.1733C2.46673 16.4859 2.89065 16.6615 3.33268 16.6615H16.666C17.108 16.6615 17.532 16.4859 17.8445 16.1733C18.1571 15.8607 18.3327 15.4368 18.3327 14.9948V9.99479L15.4577 4.25313C15.3197 3.97545 15.107 3.74177 14.8435 3.57836C14.58 3.41495 14.2761 3.32829 13.966 3.32812H6.03268C5.72261 3.32829 5.41874 3.41495 5.15522 3.57836C4.8917 3.74177 4.679 3.97545 4.54102 4.25313Z" /></svg>
    );
    if (type === 'sent') return (
        <svg {...props} viewBox="0 0 20 20"><path d="M3.0951 2.54206C3.02015 2.50548 2.93592 2.49232 2.85338 2.50431C2.77085 2.5163 2.69384 2.55288 2.6324 2.60929C2.57096 2.66569 2.52794 2.73929 2.50895 2.82051C2.48996 2.90172 2.49588 2.98677 2.52594 3.06456L4.8951 9.4204C5.03483 9.79559 5.03483 10.2085 4.8951 10.5837L2.52677 16.9396C2.49686 17.0173 2.49102 17.1022 2.51 17.1832C2.52898 17.2643 2.57191 17.3378 2.6332 17.3941C2.69449 17.4505 2.77132 17.4871 2.85369 17.4992C2.93607 17.5113 3.02018 17.4984 3.0951 17.4621L18.0951 10.3787C18.1665 10.345 18.2268 10.2917 18.269 10.225C18.3112 10.1583 18.3336 10.081 18.3336 10.0021C18.3336 9.92313 18.3112 9.84583 18.269 9.77914C18.2268 9.71246 18.1665 9.65914 18.0951 9.6254L3.0951 2.54206Z" /><path d="M5 10H18.3333" /></svg>
    );
    if (type === 'drafts') return (
        <svg {...props} viewBox="0 0 20 20"><path d="M5.00065 18.3385C4.55862 18.3385 4.1347 18.163 3.82214 17.8504C3.50958 17.5378 3.33398 17.1139 3.33398 16.6719V3.33854C3.33398 2.89652 3.50958 2.47259 3.82214 2.16003C4.1347 1.84747 4.55862 1.67188 5.00065 1.67188H11.6673L16.6673 6.67188V16.6719C16.6673 17.1139 16.4917 17.5378 16.1792 17.8504C15.8666 18.163 15.4427 18.3385 15.0007 18.3385H5.00065Z" /><path d="M11.666 1.67188V6.67187H16.666" /><path d="M8.33268 7.5H6.66602" /><path d="M13.3327 10.8281H6.66602" /><path d="M13.3327 14.1719H6.66602" /></svg>
    );
    if (type === 'spam') return (
        <svg {...props} viewBox="0 0 20 20"><path d="M9.99935 18.3385C14.6017 18.3385 18.3327 14.6076 18.3327 10.0052C18.3327 5.40284 14.6017 1.67188 9.99935 1.67188C5.39698 1.67188 1.66602 5.40284 1.66602 10.0052C1.66602 14.6076 5.39698 18.3385 9.99935 18.3385Z" /><path d="M10 6.67188V10.0052" /><path d="M10 13.3385H10.0083" /></svg>
    );
    if (type === 'trash') return (
        <svg {...props} viewBox="0 0 20 20"><path d="M15.8327 5V16.6667C15.8327 17.1087 15.6571 17.5326 15.3445 17.8452C15.032 18.1577 14.608 18.3333 14.166 18.3333H5.83268C5.39065 18.3333 4.96673 18.1577 4.65417 17.8452C4.34161 17.5326 4.16602 17.1087 4.16602 16.6667V5" /><path d="M2.5 5H17.5" /><path d="M6.66602 5.00521V3.33854C6.66602 2.89651 6.84161 2.47259 7.15417 2.16003C7.46673 1.84747 7.89065 1.67188 8.33268 1.67188H11.666C12.108 1.67188 12.532 1.84747 12.8445 2.16003C13.1571 2.47259 13.3327 2.89651 13.3327 3.33854V5.00521" /></svg>
    );
    // custom / default
    return (
        <svg {...props} viewBox="0 0 20 20"><path d="M17.5 15.8333C17.5 16.2754 17.3244 16.6993 17.0118 17.0118C16.6993 17.3244 16.2754 17.5 15.8333 17.5H4.16667C3.72464 17.5 3.30072 17.3244 2.98816 17.0118C2.67559 16.6993 2.5 16.2754 2.5 15.8333V4.16667C2.5 3.72464 2.67559 3.30072 2.98816 2.98816C3.30072 2.67559 3.72464 2.5 4.16667 2.5H7.5L9.16667 5H15.8333C16.2754 5 16.6993 5.17559 17.0118 5.48816C17.3244 5.80072 17.5 6.22464 17.5 6.66667V15.8333Z" /></svg>
    );
};

const MoveToModal = ({ isOpen, onClose, selectedIds, onMoved }) => {
    const { t } = useI18n();
    const { folders, activeFolderId, bulkMoveEmails } = useEmail();
    const [selectedFolderId, setSelectedFolderId] = useState(null);
    const [isMoving, setIsMoving] = useState(false);

    if (!isOpen) return null;

    // Show all real folders except the current one and virtual Archive folder
    const movableFolders = SYSTEM_FOLDER_ORDER.flatMap(type =>
        folders.filter(f => f.type === type && f.id !== activeFolderId && f.name !== 'Archive')
    );

    const handleMove = async () => {
        if (!selectedFolderId) return;
        setIsMoving(true);
        try {
            await bulkMoveEmails(Array.from(selectedIds), selectedFolderId);
            onMoved();
            onClose();
        } catch {
            // error already toasted in context
        } finally {
            setIsMoving(false);
        }
    };

    const handleBackdrop = (e) => {
        if (e.target === e.currentTarget && !isMoving) onClose();
    };

    return ReactDOM.createPortal(
        <div className="project-composer-overlay" onClick={handleBackdrop}>
            <div className="project-composer-modal move-to-modal" onClick={e => e.stopPropagation()}>
                <div className="project-composer-header">
                    <h2 className="project-composer-title">{t('pages.email.move_to.title')}</h2>
                    <button className="project-composer-close" onClick={onClose} disabled={isMoving} aria-label="Close">
                        <FaTimes size={16} />
                    </button>
                </div>

                <div className="project-composer-body move-to-modal-body">
                    <p className="move-to-modal-hint">
                        {t('pages.email.move_to.hint_prefix')} {selectedIds.size} {selectedIds.size > 1 ? t('pages.email.move_to.email_plural') : t('pages.email.move_to.email_singular')} {t('pages.email.move_to.hint_suffix')}
                    </p>
                    <div className="move-to-folder-list">
                        {movableFolders.map(folder => (
                            <div
                                key={folder.id}
                                className={`move-to-folder-item ${selectedFolderId === folder.id ? 'selected' : ''}`}
                                onClick={() => setSelectedFolderId(folder.id)}
                            >
                                <FolderIcon type={folder.type} />
                                <span className="move-to-folder-name">{folder.name}</span>
                                {folder.unread_count > 0 && (
                                    <span className="move-to-folder-badge">{folder.unread_count}</span>
                                )}
                                <div className="move-to-folder-radio">
                                    <div className={`move-to-radio-dot ${selectedFolderId === folder.id ? 'active' : ''}`} />
                                </div>
                            </div>
                        ))}
                        {movableFolders.length === 0 && (
                            <p className="move-to-empty">{t('pages.email.move_to.no_folders')}</p>
                        )}
                    </div>
                </div>

                <div className="project-composer-footer">
                    <button className="project-composer-btn project-composer-btn-secondary" onClick={onClose} disabled={isMoving}>
                        {t('pages.email.move_to.cancel')}
                    </button>
                    <button
                        className="project-composer-btn project-composer-btn-primary"
                        onClick={handleMove}
                        disabled={!selectedFolderId || isMoving}
                    >
                        {isMoving ? t('pages.email.move_to.moving') : t('pages.email.move_to.move')}
                    </button>
                </div>
            </div>
        </div>,
        document.body
    );
};

export default MoveToModal;
